import CustomReportChannel from '@/Enums/ReportBuilder/ReportChannel.enum';
import { TAB_LABELS } from '@/constants/reportBuilder';
import { Button } from '@mui/material';
import { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react';

interface ITabButtonProps extends ComponentPropsWithoutRef<typeof Button> {
  channel: CustomReportChannel;
  children?: ReactNode;
}

export const TabButton = forwardRef<HTMLButtonElement, ITabButtonProps>(({ channel, children, ...props }, ref) => (
  <Button
    {...props}
    ref={ref}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '68px',
      boxShadow: 'none',
      boxSizing: 'content-box',
      borderBottom: '8px solid transparent',
    }}
  >
    <div>{TAB_LABELS[channel]}</div>
    {children}
  </Button>
));

TabButton.displayName = 'TabButton';
